module.exports = __webpack_public_path__ + "static/media/whatsapp-circle-2color-green.547cd823.svg";